import { View, Text } from "react-native";
import React from "react";
import Cart from "../components/Cart";
import { styles } from "../styles/mainStyle";
import Ionicons from "@expo/vector-icons/Ionicons";
import SideMenu from "./SideMenu";
import { ScrollView, TouchableOpacity } from "react-native-web";
import { Image } from "@rneui/base";

//TODO agregar props para que convivan con navigation

const Header = (props) => {
  return (
    <View style={styles.headerContainer}>
      {!props.isBack && <SideMenu />}
      {props.isBack && (
        <Ionicons
          name="arrow-undo-outline"
          size={32}
          color="white"
          onPress={() => props.navigation.goBack()}
        />
      )}
      <TouchableOpacity onPress={() => props.navigation.navigate("Home")}>
        {props.title != "Logo" && (
          <Text style={styles.headerTitle}>{props.title}</Text>
        )}
        {props.title == "Logo" && (
          <Image
            source={require("../assets/placeholder.png")}
            style={{ width: 60, height: 60, resizeMode: "contain" }}
          />
        )}
      </TouchableOpacity>
      <Cart />
    </View>
  );
};

export default Header;
